import React from 'react'

type SwapIconProps = {
  width?: number
  height?: number
  fill?: string
}

const SwapIcon: React.FC<SwapIconProps> = ({
  width = 10,
  height = 8,
  fill = "#3452FF"
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.69415 2.73964L0.416003 2.98838C0.276415 2.99258 0.147663 2.93298 0.0860089 2.83581C0.024089 2.73856 0.0409129 2.62121 0.128665 2.53503L1.63958 1.05049C1.76401 0.928237 1.98993 0.906367 2.14438 1.00173C2.29871 1.09718 2.32317 1.27354 2.19861 1.39587L1.17265 2.40398L8.6781 2.17845C8.87628 2.1725 9.04061 2.29342 9.04503 2.44822C9.04945 2.60313 8.89232 2.73369 8.69415 2.73964Z" fill={fill} />
      <path fillRule="evenodd" clipRule="evenodd" d="M7.14188 7.7863C7.06026 7.78875 6.97739 7.7696 6.90864 7.727C6.75431 7.63164 6.73011 7.45538 6.85466 7.33294L7.88059 6.32481L0.375056 6.55033C0.176887 6.55629 0.0124387 6.43547 0.0080139 6.28056C0.00359175 6.12574 0.160863 5.99517 0.359029 5.98921L8.63691 5.74048C8.77674 5.73628 8.90549 5.79588 8.96715 5.89305C9.02881 5.99031 9.01224 6.10766 8.92449 6.19383L7.41338 7.67843C7.3444 7.74632 7.24397 7.78322 7.14181 7.78629" fill={fill} />
    </svg>
  )
}

export default SwapIcon
export type { SwapIconProps }
